import Image from "next/image";
import Link from "next/link";
import React from "react";

import { Tag } from "@/components/atoms/Tag";
import { Job } from "@/app/types";
import { CompanyLogoPlaceholder } from "@/components/molecules/LogoPlaceholder";
import useLocaleStore from "@/app/stores/useLocaleStore";

const JobListingCard = ({
  companyLogo,
  company,
  title,
  type,
  location,
  isFeatured,
  id,
}: Job) => {
  const locale = useLocaleStore((state) => state.locale);
  const { city, state, country } = location;

  return (
    <div
      className={`w-full mb-4 rounded-md border-y border-gray-200 p-4 shadow-sm dark:rounded-md  dark:border-gray-950 dark:bg-gray-700 dark:bg-none ${isFeatured && "rounded-xl bg-gradient-to-r from-blue-100 to-gray-100 dark:bg-gray-800 dark:bg-none"}`}
    >
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        {/* Left Side - Logo + Info */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 flex-1">
          {companyLogo ? (
            <Image
              src={companyLogo}
              alt={company}
              className="h-12 w-12 rounded-full object-cover"
              width={48}
              height={48}
            />
          ) : (
            <CompanyLogoPlaceholder name={company} size="md" />
          )}

          <div>
            <h4 className="text-sm font-medium text-gray-600 dark:text-gray-300">
              {company}
            </h4>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white capitalize">
              {title}
            </h3>
            <div className="mt-2 flex flex-wrap gap-2">
              <Tag
                bgColor="bg-gray-100 dark:bg-gray-950"
                textColor="text-gray-500 dark:text-gray-300"
                label={type}
              />
              {country && (
                <Tag
                  bgColor="bg-gray-100 dark:bg-gray-950"
                  textColor="text-gray-500 dark:text-gray-300"
                  label={country}
                />
              )}
              {city && <Tag
                bgColor="bg-gray-100 dark:bg-gray-950"
                textColor="text-gray-500 dark:text-gray-300"
                label={city}
              />}
              {state && <Tag
                bgColor="bg-gray-100 dark:bg-gray-950"
                textColor="text-gray-500 dark:text-gray-300"
                label={state}
              />}
            </div>
          </div>
        </div>

        {/* Right Side - Button */}
        <div className="flex justify-start sm:justify-end">
          <Link
            href={`/job/${id}`}
            className="inline-block rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700 transition"
          >
            {locale === "am" ? "አሁን ያመልክቱ" : "Apply Now →"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JobListingCard;